/**
 * MILA size fix (15.09.2026)
 * ------------------------------------------------------------------
 * Works together with:
 *   snippets/size-order.liquid
 *   snippets/product-option.liquid
 *   snippets/product-add-to-cart.liquid
 *   snippets/product-add-to-cart-sticky.liquid
 *   snippets/product-card-size-options.liquid
 *
 * What it does:
 *  1. Lets the variant picker start with NO size selected (the theme's
 *     product.js assumes a radio is always checked and would crash).
 *  2. Matches size availability (crossed-out sizes) by VALUE instead of by
 *     position, so sizes can be displayed in logical order (XS, S, M, L …)
 *     even though the variants are stored alphabetically.
 *  3. Blocks "Add to cart" until a size is chosen and shows a message
 *     next to the size picker.
 *
 * To remove the fix: delete this file and restore the snippets above from
 * the theme backup. Nothing else in the theme is touched.
 */
(function () {
  if (window.milaSizeFix) return;
  window.milaSizeFix = true;

  var DEFAULT_MSG = 'יש לבחור מידה';

  function byValue(list, value) {
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].value === value) return list[i];
    }
    return null;
  }

  function injectStyle() {
    if (document.getElementById('mila-size-fix-style')) return;
    var s = document.createElement('style');
    s.id = 'mila-size-fix-style';
    s.textContent =
      '.size-required--highlight{outline:2px solid #c0392b;outline-offset:8px;border-radius:4px;transition:outline-color .3s}';
    document.head.appendChild(s);
  }
  injectStyle();

  function showSizeMessage(msg, fieldset) {
    document.querySelectorAll('.product-form__error-message-wrapper').forEach(function (w) {
      var span = w.querySelector('.product-form__error-message');
      if (span) span.textContent = msg;
      w.removeAttribute('hidden');
    });
    if (fieldset) {
      fieldset.classList.add('size-required--highlight');
      try { fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      setTimeout(function () { fieldset.classList.remove('size-required--highlight'); }, 2500);
    }
  }

  function hideSizeMessages() {
    document.querySelectorAll('.product-form__error-message-wrapper').forEach(function (w) {
      w.setAttribute('hidden', '');
    });
  }

  /* ---------------------------------------------------------------- */
  /* Variant picker (product page + sticky bar + quick view)          */
  /* ---------------------------------------------------------------- */
  customElements.whenDefined('variant-selects').then(function () {
    var P = customElements.get('variant-selects').prototype;

    P.updateOptions = function () {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach(function (fieldset) {
        var select = fieldset.querySelector('select');
        if (select) {
          this.options.push(select.value || null);
          this.option_keys.push(select.name);
        } else if (fieldset.querySelectorAll('input').length) {
          var checked = fieldset.querySelector('input:checked');
          this.options.push(checked ? checked.value : null);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      }, this);
      this.dataset.options = this.options;
    };

    P.updateVariantText = function () {
      var fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach(function (fieldset, i) {
        var label = fieldset.querySelector('.form__label__value');
        if (label) label.innerHTML = this.options[i] === null || typeof this.options[i] === 'undefined' ? '' : this.options[i];
      }, this);
    };

    P.updateOther = function () {
      if (this.dataset.updateUrl === 'false') return;
      if (!this.other || !this.other.length) return;
      var other = this.other[0];
      var fieldsets = Array.from(other.querySelectorAll('fieldset'));
      this.options.forEach(function (option, i) {
        var fieldset = fieldsets[i];
        if (!fieldset || option === null) return;
        var select = fieldset.querySelector('select');
        if (select) {
          select.value = option;
        } else {
          fieldset.querySelectorAll('input').forEach(function (input) {
            input.checked = input.value === option;
          });
        }
      });
      other.updateOptions();
      other.updateMasterId();
      other.updateVariantText();
      other.setDisabled();
    };

    var origSetImageSetMedia = P.setImageSetMedia;
    P.setImageSetMedia = function () {
      if (!this.currentVariant) return;
      return origSetImageSetMedia.apply(this, arguments);
    };

    var origUpdateMedia = P.updateMedia;
    P.updateMedia = function () {
      if (!this.currentVariant) return;
      return origUpdateMedia.apply(this, arguments);
    };

    P.setDisabled = function () {
      if (this.isDisabledFeature != 'true') return;
      var variant_data = this.getVariantData();
      if (!variant_data) return;
      if (!this.fieldsets) this.updateOptions();

      var selected_options;
      if (this.currentVariant) {
        selected_options = this.currentVariant.options.map(function (value, index) {
          return { value: value, index: 'option' + (index + 1) };
        });
      } else {
        selected_options = (this.options || []).map(function (value, index) {
          return { value: value, index: 'option' + (index + 1) };
        }).filter(function (o) { return o.value !== null && typeof o.value !== 'undefined'; });
        if (!selected_options.length) return;
      }

      var available_options = this.createAvailableOptionsTree(variant_data, selected_options);

      this.fieldsets.forEach(function (fieldset, i) {
        var fieldset_options = Object.values(available_options)[i];
        if (!fieldset_options) return;
        var select = fieldset.querySelector('select');
        if (select) {
          fieldset_options.forEach(function (option) {
            var el = fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']');
            if (el) el.disabled = option.isUnavailable;
          });
        } else {
          fieldset.querySelectorAll('input').forEach(function (input) {
            var option = byValue(fieldset_options, input.value);
            input.classList.toggle('is-disabled', option ? option.isUnavailable : false);
          });
        }
      });
      return true;
    };

    // Elements that were upgraded before this patch loaded: initialise again.
    document.querySelectorAll('variant-selects').forEach(function (el) {
      try { el.connectedCallback(); } catch (e) { /* noop */ }
    });
  });

  /* ---------------------------------------------------------------- */
  /* Product form: block add-to-cart until a size is chosen           */
  /* ---------------------------------------------------------------- */
  customElements.whenDefined('product-form').then(function () {
    var P = customElements.get('product-form').prototype;
    var origSubmit = P.onSubmitHandler;

    P.onSubmitHandler = function (evt) {
      var idInput = this.form ? this.form.querySelector('[name=id]') : null;
      if (idInput && !idInput.value) {
        evt.preventDefault();
        var scope = this.closest('.thb-product-detail') || this.closest('#Product-Drawer') || document;
        var fieldset = scope.querySelector('fieldset[data-select-required="true"]');
        var msg = (fieldset && fieldset.dataset.selectMessage) || DEFAULT_MSG;
        showSizeMessage(msg, fieldset);
        return;
      }
      return origSubmit.call(this, evt);
    };
  });

  document.addEventListener('product:variant-change', function (e) {
    if (e.detail && e.detail.variant) hideSizeMessages();
  });

  /* ---------------------------------------------------------------- */
  /* Product cards: size chips availability by value                  */
  /* ---------------------------------------------------------------- */
  customElements.whenDefined('product-card').then(function () {
    var P = customElements.get('product-card').prototype;

    P.setDisabled = function () {
      var variant_data = this.getVariantData();
      if (!variant_data || !this.size_options) return true;
      var chips = this.size_options.querySelectorAll('.product-card-sizes--size');

      if (this.currentVariant) {
        var selected_options = this.currentVariant.options.map(function (value, index) {
          return { value: value, index: 'option' + (index + 1) };
        });
        var tree = this.createAvailableOptionsTree(variant_data, selected_options);
        var fieldset_options = Object.values(tree)[this.size_index];
        chips.forEach(function (chip) {
          var span = chip.querySelector('span');
          var option = span ? byValue(fieldset_options, span.innerText.trim()) : null;
          chip.classList.toggle('is-disabled', option ? option.isUnavailable : true);
        });
      } else {
        chips.forEach(function (chip) { chip.classList.add('is-disabled'); });
      }
      return true;
    };

    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.size_options && card.currentVariant !== undefined) {
        try { card.setDisabled(); } catch (e) { /* noop */ }
      }
    });
  });
})();
